import { cx } from '@linaria/core';
import { useState } from 'react';
import { TextIcon } from 'components/TextIcon';
import { makeInitials, stringToColor } from 'utils/strings/strings';
import { useCurrentUserId } from 'modules/Auth/hooks';
import { useUserAvatarURL } from 'modules/User/components/Settings/AvatarSection/hooks';
import { avatarImageWrapper } from './Avatar_styles';

export interface AvatarProps extends React.HTMLAttributes<HTMLImageElement> {
  alt?: string;
  userId?: string;
  size?: number;
  'data-testid'?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ userId, className, size = 32, alt, style, 'data-testid': dataTestId, ...props }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const currentUserId = useCurrentUserId();
  const fetchUserId = userId || currentUserId;
  const avatarURL = useUserAvatarURL(fetchUserId);

  const applyStyles = { ...style, width: size, height: size, minWidth: size, minHeight: size, maxWidth: size, maxHeight: size };
  const applyHiddenStyles = { ...applyStyles, display: 'none' };
  const avatarTestId = dataTestId || `avatar-${fetchUserId}`;

  return (
    <>
      {/* Fallback */}
      <TextIcon
        text={makeInitials(fetchUserId)}
        background={stringToColor(fetchUserId)}
        size={size}
        className={cx(className)}
        style={imgLoaded ? applyHiddenStyles : applyStyles}
        data-testid={`${avatarTestId}-fallback`}
        {...props}
      />

      {/* Avatar image */}
      <img
        src={avatarURL || ''}
        alt={alt || `${fetchUserId} avatar`}
        className={cx(avatarImageWrapper, className)}
        style={imgLoaded ? applyStyles : applyHiddenStyles}
        onLoad={() => setImgLoaded(true)}
        data-testid={avatarTestId}
        {...props}
      />
    </>
  );
};
